import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { UrlPath } from 'src/app/models/url-enum';
import { ModalCloseService } from 'src/services/modal-close.service';

@Component({
  selector: 'app-core',
  templateUrl: './core.component.html',
  styleUrls: ['./core.component.scss']
})
export class CoreComponent implements OnInit {

  showSessionExpiredModal = false;
  showMenu = false;
  currentUrl: string;
  urlPath: UrlPath;

  constructor(
    private router: Router,
    private modal: ModalCloseService,
  ) { }

  ngOnInit(): void {
    this.setupRouterEventSubscription();
    this.setupSessionModalSubscription();
  }

  setupSessionModalSubscription(): void {
    this.modal.showModal$.subscribe((showModal) => {
      this.showSessionExpiredModal = showModal;
    });
  }

  setupRouterEventSubscription(): void {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.handleNavigationStartEvent(val);
      }

      if (localStorage.getItem('token') === null) {
        this.showMenu = false;
      }
    });
  }

  handleNavigationStartEvent(route: NavigationStart): void {
    const url = route.url as string;
    this.currentUrl = url;

    if (url === '/' || url === '/login') {
      this.showMenu = false;
    } else {
      this.checkUrlForMenuVisibility(url);
    }
  }

  checkUrlForMenuVisibility(url: string): void {
    if (
      url.includes('/ott-onboarding/') ||
      url.includes('/packages/') ||
      url.includes('/subscribers/') ||
      url.includes('/settings/')
    ) {
      this.showMenu = true;
    } else if (url.includes('/login')) {
      this.showMenu = false;
    } else {
      this.showMenu = true;
    }
  }
}
